import React from "react";

const Bash_Ps = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Ps</h2>
      <p>Report a snapshot of current processes.</p>
      <h4 className="font-medium mt-4">Syntax</h4>
      <pre><code>ps [options]</code></pre>
      <h4 className="font-medium mt-4">Examples</h4>
      <pre><code>ps aux
ps -ef</code></pre>
      <h4 className="font-medium mt-4">Notes</h4>
      <p>Use with grep to find specific processes.</p>
    </div>
  );
};

export default Bash_Ps;
